<script setup lang="ts">
import { motion } from 'motion-v'
import { useRoute } from 'vue-router'
import { cn } from '../lib/cn'
import { isActive, NAV_MAIN, NAV_SETUP } from '../lib/nav'

const props = defineProps<{ layoutKey: string }>()
const route = useRoute()

const groups = [
  { title: null, items: NAV_MAIN },
  { title: 'Setup', items: NAV_SETUP },
]
</script>

<template>
  <nav class="flex flex-col gap-5">
    <div v-for="g in groups" :key="g.title ?? 'main'">
      <p v-if="g.title" class="mb-1.5 px-3 font-mono text-[10.5px] tracking-[0.18em] text-muted-foreground/80 uppercase">{{ g.title }}</p>
      <ul class="flex flex-col gap-0.5">
        <li v-for="item in g.items" :key="item.to">
          <RouterLink
            :to="item.to"
            :class="
              cn(
                'group relative flex h-9 items-center gap-3 rounded-lg px-3 text-[13.5px] font-medium transition-colors',
                isActive(item, route.path) ? 'text-foreground' : 'text-muted-foreground hover:text-foreground',
              )
            "
          >
            <motion.span
              v-if="isActive(item, route.path)"
              :layout-id="`nav-${props.layoutKey}`"
              class="absolute inset-0 rounded-lg border border-border bg-card shadow-card"
              :transition="{ type: 'spring', stiffness: 480, damping: 36 }"
            />
            <component :is="item.icon" :class="cn('relative size-4 transition-colors', isActive(item, route.path) ? 'text-accent' : 'group-hover:text-foreground')" />
            <span class="relative flex-1">{{ item.label }}</span>
          </RouterLink>
        </li>
      </ul>
    </div>
  </nav>
</template>
